import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

export const randomizeAvatar = () => {
  const socket = getOrCreateSocket();
  if (store.currentRoom) {
    socket.emit("randomizeAvatar", store.currentRoom);
  }
};
